// src/services/api.js
import axios from "axios";
import { useAuthStore } from "@/stores/authStore";

const API_URL = process.env.VUE_APP_API_URL || "/api/v1/";

const api = axios.create({
  baseURL: API_URL,
  timeout: 15000, // 15s
  headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
});

// request interceptor: attach token
api.interceptors.request.use((config) => {
  try {
    const auth = useAuthStore();
    if (auth?.token) {
      config.headers.Authorization = `Bearer ${auth.token}`;
    }
  } catch (e) { /* pinia pode não estar pronto, ignore */ }
  return config;
}, error => Promise.reject(error));

// response interceptor: network error friendly + 401 skeleton
api.interceptors.response.use(
  res => res,
  async (error) => {
    if (!error.response) {
      return Promise.reject({ response: { data: { message: "Verifique sua conexão." } } });
    }
    if (error.response.status === 401) {
      // tentativa de refresh (implemente refreshToken no authStore)
      try {
        const auth = useAuthStore();
        if (auth?.refreshToken) {
          await auth.refreshToken();
          // retry original request
          error.config.headers.Authorization = `Bearer ${auth.token}`;
          return api(error.config);
        } else {
          auth.logout?.();
        }
      } catch (e) {
        useAuthStore().logout?.();
      }
    }
    return Promise.reject(error);
  }
);

export default api;
